import { render } from "./GuideEditModal.vue?vue&type=template&id=337db397"
import script from "./GuideEditModal.vue?vue&type=script&lang=js"
export * from "./GuideEditModal.vue?vue&type=script&lang=js"
script.render = render

export default script